import styled from 'styled-components';

import { NewStyleColor, StyleColor } from '../../../../../utils/styles-constants';
import { hexToRgba } from '../../../../../utils/style';

interface WrapperProps {
	isDragging: boolean;
}

interface ButtonProps {
	isRemoveButton?: boolean;
}

interface IconTypeProps {
	hasText?: boolean;
}

const Wrapper = styled('div')`
	box-sizing: border-box;
	position: relative;
	height: 70px;
	padding: 8px 84px 0 33px;
	border-radius: 6px;
	background-color: ${hexToRgba(NewStyleColor.White, 10)};

	${({ isDragging }: WrapperProps) => isDragging && `
		background-color: ${hexToRgba(NewStyleColor.Blue450, 30)};
	`}
`;

const IconMove = styled('div')`
	position: absolute;
	top: 8px;
	left: 0;
	display: flex;
	justify-content: center;
	width: 33px;
	height: 33px;
	padding-top: 3px;
	color: ${hexToRgba(NewStyleColor.White, 50)};

	svg {
		width: 17px;
		height: 19px;
		fill: currentColor;
	}
`;

const PreviewWrapper = styled('div')`
	position: relative;
	display: flex;
	align-items: center;
	width: 220px;
	margin-left: 10px;
	border-radius: 4px;
	background-color: ${hexToRgba(NewStyleColor.White, 50)};
`;

const IconType = styled('div')`
	position: relative;
	flex: 0 0 38px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 38px;
	height: 38px;
	border-radius: 4px 0 0 4px;
	color: ${hexToRgba(NewStyleColor.White, 75)};

	svg {
		width: 22px;
		height: 22px;
		fill: currentColor;
	}

	${({ hasText }: IconTypeProps) => hasText && `
		&::after {
			content: 'T';
			position: absolute;
			bottom: 5px;
			right: 1px;
			font-family: serif;
			font-size: 10px;
		}
	`}
`;

const Preview = styled('img')`
	width: 100%;
	height: 38px;
	border-radius: 0 4px 4px 0;
	object-fit: cover;
`;

const Label = styled('div')`
	width: 220px;
	margin-left: 10px;
	font-family: HelveticaNeue, sans-serif;
	font-size: 10px;
	line-height: 20px;
	letter-spacing: 0.15px;
	color: ${hexToRgba(NewStyleColor.White, 75)};
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
`;

const ActionsWrapper = styled('div')`
	position: absolute;
	top: 17px;
	right: 12px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 50px;
`;

const Button = styled('button')`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	padding: 0;
	border-radius: 50%;
	border: 2px solid ${StyleColor.White};
	outline: 0;
	background-color: transparent;
	color: ${StyleColor.White};
	cursor: pointer;

	> svg {
		width: ${({ isRemoveButton }: ButtonProps) => isRemoveButton ? '8px' : '16px'};
		height: ${({ isRemoveButton }: ButtonProps) => isRemoveButton ? '8px' : '16px'};
		fill: currentColor;
	}

	&:hover {
		opacity: 0.8;
	}

	&:only-child {
		margin-left: auto;
	}
`;

export {
	Wrapper,
	IconMove,
	PreviewWrapper,
	IconType,
	Preview,
	Label,
	ActionsWrapper,
	Button,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/SliderManager/Slide/styles.ts